(function () {
    'use strict';

    angular.module("imApp").factory("skillsCertificateTypesService", [function () {
        let service = {};

        return service;
    }]);
})();
